export default __webpack_public_path__ + "static/media/todo.a57cd59f.png";